import { EngubatorRegion } from "./engubator.region";

export class EngubatorEngineerRegion extends EngubatorRegion {
    isDefault: boolean;
}